import { render, staticRenderFns } from "./HowItPay.vue?vue&type=template&id=c49334d2&scoped=true"
import script from "./HowItPay.vue?vue&type=script&lang=js"
export * from "./HowItPay.vue?vue&type=script&lang=js"
import style0 from "./HowItPay.vue?vue&type=style&index=0&id=c49334d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49334d2",
  null
  
)

export default component.exports